<template>
    <div class="dispatch-manage">
        <keep-alive :include="cachedViews">
            <router-view></router-view>
        </keep-alive>
    </div>
</template>
<script>
export default {
    name: 'dispatchManage',
    data() {
        return {
        };
    },
    computed: {
        cachedViews() {
            return this.$store.state.cachedViews;
        }
    }
};
</script>
<style lang="less">
.dispatch-manage{
    flex: 1;
    display: flex;
}
</style>
